// extracted by mini-css-extract-plugin
module.exports = {"InputEmailTags":"styles_InputEmailTags__3Calo","tagSection":"styles_tagSection__143WF","TextFieldLabel":"styles_TextFieldLabel__2qut2"};